import { render, staticRenderFns } from "./SmartBonesFunction.vue?vue&type=template&id=3b3fee4c&scoped=true"
import script from "./SmartBonesFunction.vue?vue&type=script&lang=js"
export * from "./SmartBonesFunction.vue?vue&type=script&lang=js"
import style0 from "./SmartBonesFunction.vue?vue&type=style&index=0&id=3b3fee4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3fee4c",
  null
  
)

export default component.exports